export function listPayment(params) {
    return window.axios.post("api/payment/list", params)
}

export function deletePayment(id) {
    return window.axios.post("api/payment/delete", {id: id})
}

export function updatePayment(params) {
    return window.axios.post("api/payment/update", params)
}

export function addPayment(params) {
    return window.axios.post("api/payment/add", params)
}

export function exportPaymentConfig() {
    return window.axios.post("api/payment/exportConfig", {})
}

export function getPayment(id) {
    return window.axios.post("api/payment/get", {id: id})
}

export function exportPayment(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/payment/export/excel", params, config)
}
